<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col md="6">
        <b-card title="Personal Settings">
          <b-form v-on:submit.prevent.stop="submit">
            <b-form-group id="name_label" label="Your Name" label-for="name">
              <b-input id="name" type="text" v-model="name" required></b-input>
            </b-form-group>
            <b-form-group id="email_label" label="Your Email Address" label-for="email">
              <b-input id="email" type="email" v-model="email" required></b-input>
            </b-form-group>
            <div class="text-right">
              <b-button to="/settings">Cancel</b-button>
              <b-button type="submit" variant="primary">Save</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import API from '@/lib/api'

export default {
  name: 'Personal Settings',
  components: {
  },
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'Settings', to: '/settings'}, {text: 'Personal Settings', to: '/settings/account', active: true}],
      name: this.$store.state.user.name,
      email: this.$store.state.user.email
    }
  },
  methods: {
    submit () {
      const params = {
        name: this.name,
        email: this.email
      }
      API.put('account', params, this.$store.getters.authHeaders).then((result) => {
        API.get('account', {}, this.$store.getters.authHeaders).then((response) => {
          if (response.data != null) {
            this.$store.commit('updateUser', response.data)
          }
          this.$root.showToast('Changes Saved')
          this.$router.push('/settings')
        })
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          this.errorMessage = error.response.data.message
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PersonalSettings.vue